<template>
  <div class="consent-list">
    <div class="consent-items">
      <ConsentItem
        v-for="consent in consents"
        :key="consent.id"
        :consent="consent"
        :is-selected="consent.id === selectedConsentId"
        :is-read="readConsentIds.has(consent.id)"
        @select="handleSelect"
      />
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import ConsentItem from "./ConsentItem.vue";

defineProps({
  consents: {
    type: Array,
    required: true,
  },
  selectedConsentId: {
    type: [String, Number],
    default: null,
  },
  readConsentIds: {
    type: Set,
    required: true,
  },
});

const emit = defineEmits(["select-consent"]);

const handleSelect = (consentId) => {
  emit("select-consent", consentId);
};
</script>

<style lang="scss" scoped>
.consent-list {
  .consent-items {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
}
</style>
